import type { MainLayoutUiModel } from '@client/composition/main-layout/domain/ui-model/main-layout.ui-model';
import type { AtLeastOne } from '@kiplin/web-common/utils';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMainLayoutStore = defineStore('main-layout', () => {
  const initialMainLayoutUiModel: MainLayoutUiModel = {
    navigationElements: [],
    userInfo: {
      fullName: '',
      email: '',
      companyLogoUrl: null,
      companyLabel: '',
      selectOptions: [],
      selectValue: undefined,
    },
    userInfos: {
      firstname: '',
      lastname: '',
      email: '',
      avatarImgUrl: null,
      clients: [],
    },
    clientInfos: {
      subscriptionEndDate: null,
      subscriptionStartDate: null,
      subscriptionCode: null,
      label: '',
      id: '',
    },
    subscriptionSubscriberProgress: null,
    activeItemNavigationElementId: null,
    isCreateNewGameButtonShown: false,
  };

  const mainLayoutUiModel = ref<MainLayoutUiModel>({
    ...initialMainLayoutUiModel,
  });
  const isCustomisationAppModalUiReady = ref(false);
  const isCreateGameModalUiReady = ref(false);

  function updateMainLayoutUiModel(data: AtLeastOne<MainLayoutUiModel>) {
    mainLayoutUiModel.value = {
      ...mainLayoutUiModel.value,
      ...data,
    };
  }

  function setIsCreateGameModalUiReady(value: boolean): void {
    isCreateGameModalUiReady.value = value;
  }

  function reset(): void {
    mainLayoutUiModel.value = {
      ...initialMainLayoutUiModel,
    };
    isCustomisationAppModalUiReady.value = false;
    isCreateGameModalUiReady.value = false;
  }

  return {
    mainLayoutUiModel,
    updateMainLayoutUiModel,
    isCustomisationAppModalUiReady,
    setIsCustomisationAppModalUiReady: (value: boolean) => {
      isCustomisationAppModalUiReady.value = value;
    },
    isCreateGameModalUiReady,
    setIsCreateGameModalUiReady,
    reset,
  };
});
